export default __webpack_public_path__ + "static/media/PETRONAS_Logo_Dashboard.63d7a949.svg";